import { Spinner } from "react-bootstrap";


export default function Cargando({ cargando}) {
    return (
        <>
            {cargando && <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>}
        </>
    )
}

